import classNames from "classnames";
import { useAppDispatch, useAppSelector, useScreenSize } from "hooks";
import { decodeToken } from "utils/functions/decodeToken";
import { MOBILE_WIDTH, TAB_LARGE_WIDTH } from "utils/constants";
import { HamburgerMenu, PrLogoLarge, PrTextLogo } from "components/atoms/Icon";
import { HeaderNotification } from "components/molecules";
import { Typography } from "components/atoms";
import { SelfPacedNavBar } from "../SelfPacedNavBar";
import { layout_types, setToggleMobileMenu } from "state/reducers/layoutSlice";
import { CSSTransition } from "react-transition-group";
import { PrLogoSmall } from "components/atoms/Icon/PrLogoSmall";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const SelfPacedSidebar = ({ theme }: IProps) => {
  const screen = useScreenSize();

  const payload = decodeToken();

  const dispatch: any = useAppDispatch();

  const { layoutMode, toggleMobileMenu } = useAppSelector(
    (state: {
      layout: { layoutMode: layout_types; toggleMobileMenu: boolean };
    }) => state.layout
  );

  const isDesktop = screen.width > TAB_LARGE_WIDTH;
  const isMobile = screen.width <= MOBILE_WIDTH;
  const isTab = screen.width <= TAB_LARGE_WIDTH && screen.width > MOBILE_WIDTH;

  return (
    <div className={classNames("self-page-side-bar")}>
      {isTab || isMobile ? (
        <div className="mobile-header-wrapper">
          <HamburgerMenu
            handleOnClick={() =>
              dispatch(setToggleMobileMenu(!toggleMobileMenu))
            }
          />
          <PrTextLogo />
          <HeaderNotification theme={theme} />
        </div>
      ) : null}

      <CSSTransition
        in={isDesktop || toggleMobileMenu}
        timeout={300}
        classNames="self-paced-sidebar-anim"
        mountOnEnter
        unmountOnExit
      >
        <div className="self-paced-side-bar">
          <div className="upper-section-wrapper">
            <div className="nav-logo-wrapper">
              {layoutMode === "toggle-desktop-menu" && !isTab && !isMobile ? (
                <PrLogoSmall />
              ) : (
                <>
                  {isDesktop ? <PrLogoLarge /> : null}

                  {!isMobile && payload?.testtype ? (
                    <Typography
                      styles="nav-wrapper-title"
                      variant="h5Med"
                      label={payload.testtype}
                    />
                  ) : null}
                </>
              )}
            </div>

            <SelfPacedNavBar
              theme={theme}
              isMobile={isMobile}
              isDesktop={isDesktop}
              isTab={false}
              payload={payload}
            />
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};
